<template>
	<div class="small-12 sidebarWidget flex vertical-align animated fadeIn" style="padding-top:10px;" v-if="resident">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Portal Management</h3>
        </div>
        <div class="small-12 portalManagementWidget border light borderRadius8">
            <div class="small-12 bgWrap">
                <div class="small-12 columns overview">
                    <h2 class="small-12 columns flex vertical-align">
                        Enrolled in Portal:
                        <span class="flex round vertical-align justify-center" v-if="resident.attributes.referral.registered">Yes</span>
                        <span class="auto flex borderRadius8 vertical-align justify-center columns" v-else-if="resident.attributes.site_enrollment.enroll_resident && !resident.attributes.referral.registered">Invited</span>
						<span class="flex round vertical-align justify-center" v-else>No</span>
                    </h2>
                </div>
            </div>
            <div class="small-12 referralCode columns flex justify-center">
                <div class="small-12 columns wrap borderRadius8 bgWhite flex justify-center">
                    <h6 class="small-12 columns">Referral Code:</h6>
                    <div class="small-11 columns code borderRadius4">
                        <p class="small-12 columns flex justify-center" v-if="resident.attributes.referral.code">
							{{ resident.attributes.referral.code }}
						</p>
						<p class="small-12 columns flex justify-center" v-else>
							-- -- --
						</p>
                    </div>
                </div>
            </div>
            <div class="small-12 columns inviteTimeline">
                <h6 class="small-12 columns">Enrollment Details</h6>
                <ul class="small-12 columns float-left flex">
                    <li class="small-12 flex justify-between">
                        <p>Invite Sent On </p>
                        <span v-if="resident.attributes.site_enrollment.enrollment_date">{{ resident.attributes.site_enrollment.enrollment_date | unixToDate }}</span>
						<span v-else>--</span>
                    </li>
                    <li class="small-12 flex justify-between">
                        <p>Resident Enrolled On </p>
                        <span v-if="resident.attributes.referral.date">{{ resident.attributes.referral.date | unixToDate }}</span>
						<span v-else>--</span>
                    </li>
                </ul>
            </div>
            <div class="small-12 columns action">
                <div class="small-12 columns flex justify-center">
                    <a class="blueButton borderRadius4 flex vertical-align" @click="sendEnrollmentInviteEmailHandler(resident.attributes.contact_information.email, resident.attributes.contact_information.first_name, resident.attributes.referral.code, resident.id, $route.params.id)" v-if="!resident.attributes.referral.registered">
                        <i class="material-icons addIcon borderRadius4 flex justify-center vertical-align">email</i>
                        Send Invite
                    </a>
					<a class="disabledButton borderRadius4 flex vertical-align" v-else>
                        <i class="material-icons addIcon borderRadius4 flex justify-center vertical-align">email</i>
                        Send Invite
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	// Import the events
	import { SendEnrollmentInviteEmail } from '@/events/emails/SendEnrollmentInviteEmail'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentPortalManagement',

		/*
		**  Register the mixins
		*/

		mixins: [

			DatesFilters,
			SendEnrollmentInviteEmail

		],

		/*
		**  Set the props
		*/

		props: {

			resident: {
				type: Object,
				default: () => null
			},

            property: {
				type: Object,
				default: () => null
			}

		}
		
	}

</script>